var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-image-slider slide"},[_c('div',{staticClass:"image-relative"},[_c('img',{attrs:{"src":_vm.resourceUrl('images/placeholder-for-full-size-image.png'),"alt":"Placeholder"}}),_vm._v(" "),_c('div',{staticClass:"background-image",style:({
        'background-image': `url(${_vm.resourceUrl(_vm.sliderImage.photo.url)})`
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }